export function generateFooterCSS(): string {
  return `
/* ============================================
   FOOTER
   ============================================ */

.footer {
  padding: var(--sp-16) 0 var(--sp-8);
  background: var(--c-bg-alt);
  border-top: 1px solid var(--c-border);
}

.footer__grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: var(--density-grid-gap, var(--sp-12));
  margin-bottom: var(--sp-12);
}
@media (min-width: 901px) {
  .footer__grid { grid-template-columns: 2fr repeat(3, 1fr); }
}

.footer__brand { max-width: 280px; }

.footer__logo {
  display: flex;
  align-items: center;
  gap: var(--sp-3);
  margin-bottom: var(--sp-4);
}
.footer__logo-icon {
  width: 40px;
  height: 40px;
  background: var(--c-primary);
  color: var(--c-on-primary, var(--c-white)); /* QA: A-3 */
  border-radius: var(--radius-md);
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 700;
}
.footer__logo-text {
  font-family: var(--font-display);
  font-weight: 600;
  font-size: var(--text-lg);
}

.footer__tagline {
  color: var(--c-text-light);
  font-size: var(--text-sm);
  line-height: var(--leading-relaxed);
  margin-bottom: var(--sp-5);
}

.footer__social {
  display: flex;
  gap: var(--sp-3);
}
.footer__social a {
  width: 40px;
  height: 40px;
  background: var(--c-bg);
  border: 1px solid var(--c-border);
  border-radius: var(--radius-full);
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--c-text-light);
  transition: all var(--duration-fast);
}
.footer__social a:hover {
  background: rgba(var(--c-primary-rgb) / 0.08);
  color: var(--c-primary);
  border-color: var(--c-primary);
}

.footer__column h4 {
  font-size: var(--text-sm);
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: var(--tracking-wide);
  margin-bottom: var(--sp-5);
  color: var(--c-text-muted);
}
.footer__column ul {
  list-style: none;
  display: flex;
  flex-direction: column;
  gap: var(--sp-3);
}
.footer__column a {
  color: var(--c-text-light);
  font-size: var(--text-sm);
  padding: var(--sp-1) 0;
  transition: color var(--duration-fast);
}
.footer__column a:hover { color: var(--c-text); }

.footer__bottom {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-top: var(--sp-8);
  border-top: 1px solid var(--c-border);
  font-size: var(--text-sm);
  color: var(--c-text-muted);
}

.footer__legal {
  display: flex;
  gap: var(--sp-6);
}
.footer__legal a:hover { color: var(--c-text); }

@media (max-width: 900px) {
  .footer__grid { grid-template-columns: 1fr 1fr; }
  .footer__brand { grid-column: 1 / -1; max-width: none; }
}
@media (max-width: 640px) {
  .footer__grid { grid-template-columns: 1fr; }
  .footer__bottom { flex-direction: column; gap: var(--sp-4); text-align: center; }
}
`;
}
